import { render } from "./Skill.vue?vue&type=template&id=480643ea"
import script from "./Skill.vue?vue&type=script&lang=js"
export * from "./Skill.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pavithram.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__